import { create } from 'zustand';

type MobileDrawerStore = {
  mobileDrawerOpen: boolean;
  setMobileDrawerOpen: (value: boolean) => void;
};

export const useMobileDrawerStore = create<MobileDrawerStore>()((set) => ({
  mobileDrawerOpen: false,
  setMobileDrawerOpen: (value) => set({ mobileDrawerOpen: value }),
}));
